function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.4375 19.1875C22.3475 21.4375 17.3413 22 14 22C10.6587 22 5.6525 21.4375 5.5625 19.1875L5.51187 17.8521C5.50737 17.7182 5.68062 17.6485 5.7605 17.7576C6.90687 19.3259 11.1121 19.75 14 19.75C16.8879 19.75 21.0942 19.3259 22.2395 17.7576C22.3194 17.6485 22.4926 17.7182 22.4881 17.8521L22.4375 19.1875ZM22.5703 16.4031C22.6839 13.3004 23 3.4375 23 3.4375C23 1.5025 18.3312 0.625 14 0.625C9.66875 0.625 5 1.5025 5 3.4375C5 3.4375 5.31612 13.3004 5.42975 16.4031C2.4215 17.3312 0.5 18.7375 0.5 20.3125C0.5 23.1081 6.54463 25.375 14 25.375C21.4554 25.375 27.5 23.1081 27.5 20.3125C27.5 18.7375 25.5785 17.3312 22.5703 16.4031"
});

function SvgIcAreaTopHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaTopHat);
export default ForwardRef;